import React from 'react';
import { connect } from 'react-redux';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, PieChart, Pie, Sector, Cell, BarChart, Bar } from 'recharts'
import Select from 'react-select';
import moment from 'moment-timezone';
import ui from 'redux-ui';
import i18next from "i18next";
import AlertDashboardTagsForm from './alert_dashboard_tags_form';

import { DashboardService, GroupingsService, GroupsService } from '../../services';

const LINECOLORS = ['#556484', '#2CD5AD', '#4A90E2'];

const CATEGORYCOLORS = ['#1AB590', '#205799', '#FFBB28'];
const AWARENESSCOLORS = ['#2CD5AD', '#D52339'];
const ACTIONCOLORS = ['#2CD5AD', '#205799'];
const CRITICALCOLORS = ['#D52339', '#63B1C2', '#F5A623'];

@ui({
  key: 'monitoring-dashboard',
  persist: true,
  state: {
    selectedGroup: null,
    selectedGrouping: null,
    filterTimeframeValue: null,
    tags: null
  }
})
@connect(state => {
  return {
    me: state.user.me,
    currentGrouping: state.currentGrouping.currentGrouping
  }
})
class AlertDashboardReport extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
          filterTimeframeValue: this.props.ui.filterTimeframeValue == null ? { value: 0, label: i18next.t('form-labels.last-twelve-hours') } : this.props.ui.filterTimeframeValue,
          lineData: [],
          lineKeys: [],
          skipInterval: 0,
          alertAreaPieData: [],
          alertAreaTotal: 0,
          awarenessPieData: [],
          awarenessTotal: 0,
          criticalPieData: [],
          criticalTotal: 0,
          actionBarData: [],
          filterGroupOptions: null,
          filterGroupValue: null,
          filterGroupingOptions: null,
          filterGroupingValue: null,
          hasError: false,
          animationDuration: 500,
          isAnimationActive: true,
          curGrouping: {id: this.props.currentGrouping.id, name: this.props.currentGrouping.name},
          disableTags: this.props.ui.tags ? this.props.ui.tags.length == 2 : false,
          tags: this.props.ui.tags
      };
  }

  componentDidMount() {
    this.refresh();
    this.refreshInterval = setInterval(() => {
      this.setState({ isAnimationActive: false });
      this.refresh();
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.refreshInterval);
  }

  refresh() {
    if (this.state.filterGroupingOptions) {
      this.refreshSecondary();
    } else {
      if (this.props.me.availableGroupings && this.props.me.availableGroupings.length > 0 && this.props.me.availableGroupings[0].children == null) {
        setTimeout(() => {
          let groupingFilterOptions = [{
            label: null,
            options: this.props.me.availableGroupings.map(grouping => {
                        return {
                          label: grouping.name,
                          value: `${grouping.id}`
                        }
                      })
          }];
          this.setState({
            filterGroupingOptions: groupingFilterOptions,
            filterGroupingValue: {value: this.state.curGrouping.id, label: this.state.curGrouping.name}
          });
          if (this.state.tags != null) {
            this.setState({showReports: true, loading:true}, () => this.refreshSecondary())
          }          
        }, 100);
      } else {
        GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then(response => {
          const groupingFilterOptions = response.groupings;
          this.setState({
            filterGroupingOptions: groupingFilterOptions,
            filterGroupingValue: {value: this.state.curGrouping.id, label: this.state.curGrouping.name}
          });
          if (this.state.tags != null) {
            this.setState({showReports: true, loading:true}, () => this.refreshSecondary())
          }
        }).catch(error => {
          console.error(error);
          this.state.localErrorHandler(error.message);
        });
      }
    }
  }

  refreshSecondary() {
    if (this.state.showReports) {
      this.queryAlerts();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filterTimeframeValue != this.state.filterTimeframeValue) {
      this.queryAlerts();
    }
  }

  queryAlerts() {
    if (this.state.showReports) {
      const filterGroupId = -1;
      const filterGroupingId = this.state.filterGroupingValue == null ? -1 : this.state.filterGroupingValue.value;
      // TODO default these if they don't exist
      const categoryFilterIds = [this.state.tags[0].id,this.state.tags[1].id]; //this.props.me.userPreferences
                                     //          .filter(pref => pref.token == 'dashboard_aotf_slot1' || pref.token == 'dashboard_aotf_slot2')
                                    //          .map(pref => pref.numericValue);


      DashboardService.getAlertsByTime(this.state.filterTimeframeValue.value, filterGroupId, filterGroupingId, categoryFilterIds).then(response => {
        var timesFound = [];
        var alertsByTime = [];
        var alertAreaTotals = {};
        response.alerts.alertsOverTime.forEach(alertData => {
          if (!timesFound.includes(alertData.timestamp)) {
            var duplicateTimestamps = [];
            let flatAlertData = response.alerts.alertsOverTime
                                    .filter(alert => alert.timestamp === alertData.timestamp)
                                    .reduce((result, alert) => {
              if (duplicateTimestamps[`${alert.triggeringTagName}-${alert.timestamp}`]) return result;
              duplicateTimestamps[`${alert.triggeringTagName}-${alert.timestamp}`] = true;

              result[alert.triggeringTagName] = alert.count;
              result['Overall'] = (result['Overall'] == null ? 0 : result['Overall']) + alert.count;

              alertAreaTotals[alert.triggeringTagName] = (alertAreaTotals[alert.triggeringTagName] == null ? 0 : alertAreaTotals[alert.triggeringTagName]) + alert.count;

              return result;
            }, {});
            flatAlertData['label'] = moment(alertData.timestamp).format(response.alerts.timeDisplayFormat);
            alertsByTime.push(flatAlertData);
            timesFound.push(alertData.timestamp);
          }
        });

        var alertAreaPieData = [];
        var alertAreaTotal = 0;
        var pointLineKeys = [<Line key={0} type="monotone" dataKey="Overall" stroke={LINECOLORS[0]} activeDot={{r: 8}} isAnimationActive={this.state.isAnimationActive} animationDuration={this.state.animationDuration}/>];
        Object.keys(alertAreaTotals).forEach((key, index) => {
          alertAreaPieData.push({ name: key, value: alertAreaTotals[key] });
          alertAreaTotal += alertAreaTotals[key];

          var color = LINECOLORS[index+1] ? LINECOLORS[index+1] : '#' + Math.floor(Math.random()*16777215).toString(16);
          pointLineKeys.push(<Line key={index+1} type="monotone" dataKey={key} stroke={color} activeDot={{r: 8}} isAnimationActive={this.state.isAnimationActive} animationDuration={this.state.animationDuration}/>);
        });

        var awarenessPieData = [];
        var awarenessTotal = 0;
        Object.entries(response.alerts.alertAwareness).map(([key,value], index)=>{
          awarenessPieData.push({name: key, value: value});
          awarenessTotal += value;
        });

        var criticalPieData = [];
        var criticalTotal = 0;
        Object.entries(response.alerts.alertsByCriticality).map(([key,value], index)=>{
          criticalPieData.push({name: key, value: value});
          criticalTotal += value;
        });

        var actionBarData = [];
        Object.entries(response.alerts.timeToAction).map(([key,value], index)=>{
          actionBarData.push({label: key, minutes: Math.round(value)});
        });

        this.setState({
          lineData: alertsByTime,
          skipInterval: response.alerts.alertsOverTimeSkipInterval,
          alertAreaPieData: alertAreaPieData,
          alertAreaTotal: alertAreaTotal,
          lineKeys: pointLineKeys,

          awarenessPieData: awarenessPieData,
          awarenessTotal: awarenessTotal,

          criticalPieData: criticalPieData,
          criticalTotal: criticalTotal,

          actionBarData: actionBarData,
          loading: false
        });
      }).catch(error => {
        console.error(error); // TODO handle error
      });
    }
  }

  setIntialTags(){
    let tagsData =[];
    const existingTags = this.props.ui.tags
    if (existingTags) {
      Object.keys(existingTags).map(function(key) {
        tagsData.push({label : existingTags[key].name, value:existingTags[key].id })
      });
    }
    return tagsData;
  }

  tagsUpdated(data) {
    let tagsData =[];
    Object.keys(data).map(function(key) {
      if(key!== 'preventDefault')
        tagsData.push({id : data[key].value, name: data[key].label })
    });
    if (tagsData.length == 2) {
      this.setState({ tags: tagsData, disableTags: true }, () => this.saveTagsValue());
    } else {
      this.setState({ tags: tagsData, disableTags: false, showReports: false });
    }
  }

  saveTagsValue() {
    if (this.state.disableTags) {
      this.props.updateUI('tags', this.state.tags);
      this.setState({ showReports: true, loading: true }, () => this.queryAlerts());
    }
  }


  updateFilterTimeframeValue(selectedValue) {
    this.props.updateUI('filterTimeframeValue', selectedValue);

    this.setState({
      filterTimeframeValue: selectedValue
    });
  }

  updateFilterGroupValue(newValue) {
    this.props.updateUI('selectedGrouping', null);
    this.props.updateUI('selectedGroup', newValue);

    this.setState({
      filterGroupValue: newValue,
      filterGroupingOptions: null,
      filterGroupingValue: null,
      hasError: false
    }, () => this.queryAlerts());

    this.loadGroupingsForGroup(newValue);
  }

  loadGroupingsForGroup(group, callback = null) {
    if (group && group.value != -1) {
      GroupsService.listAllGroupingsForGroup(group.value).then(response => {
        let filterGroupingOptions = response.groupings.map(grouping => ({ value: grouping.id, label: grouping.name }));
        filterGroupingOptions.unshift({ value: -1, label: 'All' });
        this.setState({
          filterGroupingOptions: filterGroupingOptions,
          filterGroupingValue: this.props.ui.selectedGrouping == null ? filterGroupingOptions[0] : this.props.ui.selectedGrouping
        }, callback);
      }).catch(error => {
        console.error(error);
        this.state.setState({ hasError: true });
        this.state.localErrorHandler(error.message);
      });
    }
  }

  updateFilterGroupingValue(newValue) {
    this.props.updateUI('selectedGrouping', newValue);

    this.setState({
      filterGroupingValue: newValue
    }, () => this.queryAlerts());
  }

  render() {
    if (!this.state.filterGroupingOptions) {
      return (
        <div className="loader">Loading...</div>
      );
    }

    const renderLegend = (props) => {
      return (
        <div className="chart-legend chart-legend-round">
          <ul className="list-inline chart-legend-data">
          { props.payload.map((entry, index) => ( <li className={entry.value} key={`item-${index}`} style={{}}>{entry.value}</li> )) }
          </ul>
        </div>
      );
    }
//<div><div className="row"><div className="op-page-header"><div className="op-page-header__left"><h2 className="op-page-header__title">HACCP Exception Report</h2></div></div></div>
    return (
      <div>
        <div className="row">
          <div className="op-page-header">
            <div className="op-page-header__left">
              <h2 className="op-page-header__title">Event Dashboard</h2>
              <ul className="list-inline clearfix chart-card-title">
                <li className="pull-left"></li>
                <li className="pull-right">
                  <span className="dashboard-refresh">
                    <a onClick={() => {
                      if (this.state.showReports) {
                        this.setState({loading:true})
                      }
                      this.refresh()}
                    }>
                      <i className="op-icon op-icon-refresh"></i>
                    </a>
                  </span>
                  <span className="time-select fade-in" style={{zIndex: 920}}>
                    <span className="time-select-label">Timeframe</span>
                    <Select
                        options={[
                          {value: 0, label: i18next.t('form-labels.last-twelve-hours')},
                          {value: 1, label: i18next.t('form-labels.last-twenty-four-hours')},
                          {value: 2, label: i18next.t('form-labels.last-week')},
                          {value: 3, label: i18next.t('form-labels.last-month')},
                          {value: 4, label: i18next.t('form-labels.last-year')}
                        ]}
                        clearable={false}
                        value={this.state.filterTimeframeValue}
                        onChange={this.updateFilterTimeframeValue.bind(this)}
                        searchable={false}
                      />
                  </span>

                  { this.state.filterGroupingOptions &&
                    <span className="time-select fade-in" style={{zIndex: 910}}>
                      <span className="time-select-label">Group</span>
                      <Select
                        ref="filterSelect"
                        options={this.state.filterGroupingOptions}
                        disabled={!(this.state.filterGroupingOptions.length > 0)}
                        name="selected-filter"
                        clearable={false}
                        value={this.state.filterGroupingValue}
                        onChange={this.updateFilterGroupingValue.bind(this)}
                        searchable={true}
                        placeholder={i18next.t('select')}
                      />
                    </span>
                  }
                  <AlertDashboardTagsForm
                      isDisabled = {this.state.disableTags}
                      onSelection={this.tagsUpdated.bind(this)}
                      initialValues={{ roles: this.setIntialTags() }}
                  />

                  {/* <span className="time-select">
                    <text><tspan className="time-select-label">Group</tspan></text>
                    <Select
                      ref="filterGroupSelect"
                      options={this.state.filterGroupOptions}
                      clearable={false}
                      name="selected-filter-by"
                      value={this.state.filterGroupValue}
                      onChange={this.updateFilterGroupValue.bind(this)}
                      searchable={true}
                    />
                  </span> */}
                </li>
              </ul>
            </div>
          </div>
        </div>
        {!this.state.showReports &&

          <div className="inner op-content-box">
            <ul className="list-inline clearfix chart-card-title">
            <li className="pull-left"><h5>Please select two tags to query with</h5></li>
            </ul>
          </div>
        }
        {this.state.loading &&
          <div className="loader">Loading...</div>
        }
        {this.state.showReports && !this.state.loading &&
        <center>
          <div style={{maxWidth:"1024px"}}>
            <div className="row">
              <div className="col-lg-8 col-md-8 chart-card chart-card-alerts-over-time">
                <div className="inner op-content-box">
                  <ul className="list-inline clearfix chart-card-title">
                    <li className="pull-left"><h5>Events over time</h5></li>
                    {/*
                    <li className="pull-right"><a href=""><span className="op-icon op-generic-icon-chart-tools"></span></a></li>
                    */}
                  </ul>


                  <div className="chart-data text-center">
                    <LineChart width={600} height={260} data={this.state.lineData}
                               margin={{top: 10, right: 30, left: -25, bottom: 5}}>
                        <XAxis dataKey="label" interval={this.state.skipInterval}/>
                        <YAxis domain={['auto', 'dataMax + 1']}   />
                        <CartesianGrid strokeDasharray="3 3"/>
                        <Tooltip/>
                        <Legend content={renderLegend} iconType='circle' iconSize={7}/>
                        {this.state.lineKeys}
                    </LineChart>
                  </div>

                </div>
              </div>

              <div className="col-lg-4 col-md-4 chart-card chart-card-alert-by-category">
                <div className="inner op-content-box">
                  <ul className="list-inline clearfix chart-card-title">
                    <li className="pull-left"><h5>Events by Area</h5></li>
                    {/*
                    <li className="pull-right"><a href=""><span className="op-icon op-generic-icon-chart-tools"></span></a></li>
                    */}
                  </ul>
                  <div className="chart-data text-center">
                    <PieChart width={260} height={126} label={<Text verticalAnchor="middle"/>}>
                            <text x={130} y={90} textAnchor="middle" dominantBaseline="middle">
                                <tspan className="piechart-text-val">{this.state.alertAreaTotal}</tspan>
                                <tspan className="piechart-text-label" x={130} y={110}>Total</tspan>
                            </text>
                            <Pie
                              data={this.state.alertAreaPieData}
                              cx={130}
                              cy={135}
                              startAngle={180}
                              endAngle={0}
                              innerRadius={80}
                              outerRadius={120}
                              fill="#8884d8"
                              paddingAngle={0}
                              isAnimationActive={this.state.isAnimationActive}
                              animationDuration={this.state.animationDuration}
                            >
                            {
                                this.state.alertAreaPieData.map((entry, index) => <Cell key={`entry-${index}`} fill={CATEGORYCOLORS[index % CATEGORYCOLORS.length]}/>)
                            }
                            </Pie>
                            <Tooltip/>
                    </PieChart>
                  </div>

                  <div className="chart-legend chart-legend-rectangle">
                    <ul className="list-inline chart-legend-data">
                      <li className="legend-data-food-safety">
                          {(this.state.alertAreaPieData[0]) ? this.state.alertAreaPieData[0].value : 0}<span>{(this.state.alertAreaPieData[0]) ? this.state.alertAreaPieData[0].name : 'N/A'}</span>
                      </li>
                      <li className="legend-data-facilities">
                          {(this.state.alertAreaPieData[1]) ? this.state.alertAreaPieData[1].value : 0}<span>{(this.state.alertAreaPieData[1]) ? this.state.alertAreaPieData[1].name : 'N/A'}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-4 chart-card chart-card-alert-awareness">
                <div className="inner op-content-box">
                  <ul className="list-inline clearfix chart-card-title">
                    <li className="pull-left"><h5>Event Awareness</h5></li>
                    {/*
                    <li className="pull-right"><a href=""><span className="op-icon op-generic-icon-chart-tools"></span></a></li>
                    */}
                  </ul>
                  <div className="chart-data text-center">
                    <PieChart width={260} height={126}>
                            <text x={130} y={90} textAnchor="middle" dominantBaseline="middle">
                                <tspan className="piechart-text-val">{this.state.awarenessTotal}</tspan>
                                <tspan className="piechart-text-label" x={130} y={110}>Events</tspan>
                            </text>
                            <Pie
                              data={this.state.awarenessPieData}
                              cx={130}
                              cy={135}
                              startAngle={180}
                              endAngle={0}
                              innerRadius={80}
                              outerRadius={120}
                              fill="#8884d8"
                              paddingAngle={0}
                              isAnimationActive={this.state.isAnimationActive}
                              animationDuration={this.state.animationDuration}
                            >
                            {
                                this.state.awarenessPieData.map((entry, index) => <Cell key={`entry-${index}`} fill={AWARENESSCOLORS[index % AWARENESSCOLORS.length]}/>)
                            }
                            </Pie>
                            <Tooltip/>
                    </PieChart>
                  </div>

                  <div className="chart-legend chart-legend-rectangle">
                    <ul className="list-inline chart-legend-data">
                      <li className="legend-data-aknowledged">
                          {(this.state.awarenessPieData[0]) ? this.state.awarenessPieData[0].value : 0}<span>ACKNOWLEDGED EVENTS</span>
                      </li>
                      <li className="legend-data-unaknowledged">
                          {(this.state.awarenessPieData[1]) ? this.state.awarenessPieData[1].value : 0}<span>UNACKNOWLEDGED EVENTS</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 chart-card chart-card-time-to-action">
                <div className="inner op-content-box">
                  <ul className="list-inline clearfix chart-card-title">
                    <li className="pull-left"><h5>Time to Action</h5></li>
                    {/*
                    <li className="pull-right"><a href=""><span className="op-icon op-generic-icon-chart-tools"></span></a></li>
                    */}
                  </ul>
                  <div className="chart-data text-center">
                        <BarChart width={250} height={160} layout="vertical" data={this.state.actionBarData}
                                  margin={{left: 20, top: 20}}
                                  barCategoryGap='5%'>
                           <XAxis type="number"/>
                           <YAxis type="category" dataKey="label" hide={true}/>
                           <Bar dataKey="minutes" fill="#2CD5AD" isAnimationActive={this.state.isAnimationActive} animationDuration={this.state.animationDuration}>
                           {
                            this.state.actionBarData.map((entry, index) => <Cell key={`entry-${index}`} fill={ACTIONCOLORS[index % ACTIONCOLORS.length]}/>)
                           }
                           </Bar>
                           <Tooltip/>
                        </BarChart>
                  </div>

                  <div className="chart-legend chart-legend-rectangle chart-legend-remove-top-space">
                    <ul className="list-inline chart-legend-data">
                      <li className="legend-data-time-to-acknowledge">
                          {(this.state.actionBarData[0]) ? Math.round(this.state.actionBarData[0].minutes): 'N/A'}<span>TIME TO ACKNOWLEDGE</span>
                      </li>
                      <li className="legend-data-time-to-resolve">
                          {(this.state.actionBarData[1]) ? Math.round(this.state.actionBarData[1].minutes): 'N/A'}<span>TIME TO RESOLVE</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 chart-card chart-card-alerts-by-criticality">
                <div className="inner op-content-box">
                  <ul className="list-inline clearfix chart-card-title">
                    <li className="pull-left"><h5>Events by Criticality</h5></li>
                    {/*
                    <li className="pull-right"><a href=""><span className="op-icon op-generic-icon-chart-tools"></span></a></li>
                    */}
                  </ul>
                  <div className="chart-data text-center">
                    <PieChart width={260} height={126}>
                            <text x={130} y={90} textAnchor="middle" dominantBaseline="middle">
                                <tspan className="piechart-text-val">{this.state.criticalTotal}</tspan>
                                <tspan className="piechart-text-label" x={130} y={110}>Total</tspan>
                            </text>
                            <Pie
                              data={this.state.criticalPieData}
                              cx={130}
                              cy={135}
                              startAngle={180}
                              endAngle={0}
                              innerRadius={80}
                              outerRadius={120}
                              fill="#8884d8"
                              paddingAngle={0}
                              isAnimationActive={this.state.isAnimationActive}
                              animationDuration={this.state.animationDuration}
                            >
                            {
                                this.state.criticalPieData.map((entry, index) => <Cell key={`entry-${index}`} fill={CRITICALCOLORS[index % CRITICALCOLORS.length]}/>)
                            }
                            </Pie>
                            <Tooltip/>
                    </PieChart>
                  </div>

                  <div className="chart-legend chart-legend-rectangle">
                    <ul className="list-inline chart-legend-data">
                      <li className="legend-data-critical">
                          {(this.state.criticalPieData[0]) ? this.state.criticalPieData[0].value : 0} <span>CRITICAL</span>
                      </li>
                      <li className="legend-data-minor">
                          {(this.state.criticalPieData[1]) ? this.state.criticalPieData[1].value : 0} <span>MINOR</span>
                      </li>
                      <li className="legend-data-warnings">
                          {(this.state.criticalPieData[2]) ? this.state.criticalPieData[2].value : 0} <span>WARNINGS</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </center>
      }
      </div>
    );
  }
}

export default AlertDashboardReport;
